import { sanitiseHtml } from '@/utils/strings';
import type { FC, HTMLAttributes } from 'react';
import { useMemo } from 'react';

export const MarkedText: FC<{ value: string } & HTMLAttributes<HTMLSpanElement>> = ({ value, ...rest }) => {
    if (!value?.includes('<mark>')) {
        return <span {...rest}>{value}</span>;
    }
    const processedHtml = useMemo(() => {
        return sanitiseHtml(value, ['mark']);
    }, [value]);
    return <span dangerouslySetInnerHTML={{ __html: processedHtml }} {...rest} />;
};
